import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';
import { RegisterButton } from '../components/RegisterButton';

export function WhyParticipate() {
  const { whyParticipate } = conventionContent;
  return (
    <Box
      component='section'
      id={whyParticipate.sectionId}
      aria-labelledby={whyParticipate.headingId}
      sx={{
        backgroundColor: 'background.default',
        paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(120) },
      }}
    >
      <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(96) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(157.756), laptop: pxToRem(192) },
            height: { mobile: pxToRem(93), laptop: pxToRem(145) },
            flexShrink: 0,
          }}
        >
          <CornerFrame
            corner='bottom-right'
            inset={{
              mobile: { horizontal: 13.089, vertical: 13.604 },
              laptop: { horizontal: 32, vertical: 30 },
            }}
            radius={{ mobile: 19.054, laptop: 29 }}
          />
          <Typography
            component='h2'
            id={whyParticipate.headingId}
            variant='h2'
            sx={{
              position: 'absolute',
              top: { mobile: pxToRem(3), laptop: pxToRem(8) },
              left: { mobile: pxToRem(75), laptop: 0 },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(137), laptop: pxToRem(159) },
              fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
              lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
              textAlign: { mobile: 'center', laptop: 'start' },
              margin: 0,
              color: 'primary.main',
            }}
          >
            {whyParticipate.headingLines.map((line, i) => (
              <Box component='span' key={i} sx={{ display: 'block' }}>
                {line}
              </Box>
            ))}
          </Typography>
        </Box>
        <Stack
          gap={pxToRem(12)}
          sx={{
            width: { mobile: pxToRem(304), laptop: pxToRem(635) },
            alignItems: { mobile: 'center', laptop: 'flex-start' },
            color: 'primary.main',
            textAlign: { mobile: 'center', laptop: 'left' },
          }}
        >
          <Stack
            gap={{ mobile: pxToRem(20), laptop: pxToRem(24) }}
            sx={{ width: { mobile: pxToRem(300), laptop: '100%' } }}
          >
            {whyParticipate.paragraphs.map((p, index) => (
              <Typography
                key={index}
                sx={{
                  fontFamily: '"Roboto", sans-serif',
                  fontWeight: p.emphasis === 'bold' ? 900 : 400,
                  fontSize: { mobile: pxToRem(16), laptop: pxToRem(20) },
                  lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
                  margin: 0,
                }}
              >
                {p.text}
              </Typography>
            ))}
          </Stack>
          <RegisterButton
            tone="onLight"
            label={whyParticipate.registerCta.label}
            href={whyParticipate.registerCta.href}
            ariaLabel={whyParticipate.registerCta.ariaLabel}
            sx={{ width: { mobile: '100%', laptop: pxToRem(158) } }}
          />
        </Stack>
      </SectionInner>
    </Box>
  );
}
